import React, {Component} from 'react';
import {LogicListItem} from "./LogicListItem";

export default class LogicList extends Component {
  render() {
    const {
      logics,
      searchValue,
      onLogicSelectedChange,
      selected,
      logicUrl,
      showToastForBackend,
      showToastForFrontend
    } = this.props
    return (
        <div className="panel-container">
          <div className="logics">
            {
              logics.map((logic, index) => (
                  logic.name.toLowerCase().includes(
                      searchValue.toLowerCase())
                      ? <LogicListItem logic={logic} key={index}
                                       onChange={() => onLogicSelectedChange(
                                           index)}
                                       selected={selected[index].isSelected}/>
                      : ""
              ))
            }
          </div>
        </div>
    );
  }
}


